import React from 'react';

/**
 * Caregiver status badge (FECOA-1375). Status values are derived server-side
 * — see the backend `derive_status` helper. The four canonical values are:
 *   - Active                  → green
 *   - Pending First Login     → amber
 *   - Locked                  → red
 *   - Deactivated             → gray
 */
export const STATUS_VALUES = ['Active', 'Pending First Login', 'Locked', 'Deactivated'];

const styles = {
  Active:
    'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/40 dark:border-emerald-500/30',
  'Pending First Login':
    'bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/40 dark:border-amber-500/30',
  Locked:
    'bg-rose-500/15 text-rose-700 dark:text-rose-400 border-rose-500/40 dark:border-rose-500/30',
  Deactivated:
    'bg-gray-500/15 text-gray-700 dark:text-gray-400 border-gray-500/40 dark:border-gray-500/30',
};

const CaregiverStatusBadge = ({ status, className = '' }) => {
  const tone = styles[status] || styles.Deactivated;
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap px-2.5 py-0.5 rounded-full text-xs font-medium border ${tone} ${className}`}
    >
      {status}
    </span>
  );
};

export default CaregiverStatusBadge;
